import { Area } from './types/Area';

export const boundingBoxOf = (areas: Area[]) => {

    if (areas.length < 1) {
        return undefined;
    }

    const boxes = areas.map(a => ({
        x: a.x,
        y: a.y,
        width: a.width,
        height: a.height
    }));

    const x = Math.min(...boxes.map(b => b.x));
    const y = Math.min(...boxes.map(b => b.y));
    const width = Math.max(...boxes.map(b => b.x + b.width)) - x;
    const height = Math.max(...boxes.map(b => b.y + b.height)) - y;

    return {x, y, width, height};
};